import { render, staticRenderFns } from "./DetailsCourseSubjectItem.vue?vue&type=template&id=28b6f730&scoped=true&"
import script from "./DetailsCourseSubjectItem.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseSubjectItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCourseSubjectItem.vue?vue&type=style&index=0&id=28b6f730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6f730",
  null
  
)

export default component.exports